import * as AWS from 'aws-sdk';
import {IVideoModel, VideoModel} from "./video";
import config from 'config';
import {utility} from '../utilites/index';

export interface IVideoAwsModel {
  access_key_id?: string;
  secret_access_key?: string;
  session_token?: string;
  bucket?: string;
  pipeline_id?: string;
  preset_id?: string;
  file_key?: string;
  job_key?: string;
  output_prefix?: string;
  s3_key?: string;
  region?: string;
  m3u8_url?: string;
}


export class AwsVideo implements IVideoModel {
  readonly isSaved: boolean;
  readonly url: string;

  constructor(params: IVideoModel) {
    this.isSaved = params.isSaved;
    this.url = params.url;
  }

  static async getCredentials(): Promise<IVideoAwsModel> {
    const AUTH_CLUB = 'club';
    const club = JSON.parse(sessionStorage.getItem(AUTH_CLUB));
    return await utility.networkLayer.getJson(`${config.backOfficeBasePath}/clubs/${club.id}/videos/aws_credentials`);
  }

  static async uploadVideo(fileObj: VideoModel): Promise<AwsVideo> {
    let creds = await this.getCredentials();

    let {file} = fileObj;
    let credentials = {
      accessKeyId: creds.access_key_id,
      secretAccessKey: creds.secret_access_key,
      sessionToken: creds.session_token
    };
    let elasticParams = {
      PipelineId: creds.pipeline_id,
      OutputKeyPrefix: creds.output_prefix,
      Input: {
        Key: creds.s3_key
      },
      Output: {
        Key: creds.job_key,
        PresetId: creds.preset_id,
        SegmentDuration: '3'
      },
      Playlists: [
        {
          Format: 'HLSv3',
          Name: creds.file_key,
          OutputKeys: [creds.job_key]
        }
      ]
    };

    let elasticTranscoder = new AWS.ElasticTranscoder({
      ...credentials,
      region: creds.region
    });
    let AWSS3Config = new AWS.S3({credentials});

    AWSS3Config.upload({
      Key: creds.s3_key,
      ContentType: file.type,
      Bucket: creds.bucket,
      Body: file,
      ACL: 'public-read'
    }, function (err, data) {
      if (err) {
        console.error('There was an error uploading your video: ', err.message);
      }
      if (data) {
        elasticTranscoder.createJob(elasticParams, function (err, data) {
          if (err) console.error(err, err.stack); // an error occurred
        });
      }
    });

    return new AwsVideo({isSaved: true, url: creds.m3u8_url});
  }


}



// WEBPACK FOOTER //
// ./src/api/videoAws.ts